import { ILmsProfileModel } from 'models/lmsProfile.model'
import api from '../../..'

const createProfileUsers = (
  id: number | string,

  users: number[]
) => {
  return api
    .post(`administration/lms_profiles/${id}/users`, {
      user_ids: users,
    })
    .then(({ data }): ILmsProfileModel => data)
}

export default createProfileUsers
